import { render, staticRenderFns } from "./messagePin.vue?vue&type=template&id=63b3ecab&"
import script from "./messagePin.vue?vue&type=script&lang=js&"
export * from "./messagePin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports